import EventEmitter from './EventEmitter';

const events = new EventEmitter();

export default events;